// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legacy-article h1,.legacy-article h2,.legacy-article h3,.legacy-article h4,.legacy-article p{all:unset;display:block}.legacy-article button{cursor:pointer}.legacy-article .body-text{font-weight:500;font-size:16px;line-height:150%}", ""]);
// Exports
module.exports = exports;
